export enum ApiController {
  user = 'users',
  role = 'roles',
  company = 'companies',
  category = 'categories',
  discount = 'discounts',
  recent = 'recently-viewed-discounts',
  location = 'locations',
  country = 'countries',
  auth = 'oauth2/authorization/keycloak',
  authAlumni = 'oauth2/authorization/keycloak-alumni',
  rates = 'rates',
  discountRequest = 'discount-demands',
  me = 'my',
  unread = 'unread',
  statistics = 'statistics',
  notifications = 'notifications',
  userNotifications = 'user-notifications',
  benefits = 'benefits',
  favorites = 'favourites',
  locationResponsibility = 'locations-responsibility',
  archivedDiscounts = 'discounts/archived',
  invitations = 'invitations',
}

export enum UserEndPoint {
  auth = 'auth',
  alumni = 'alumni',
  getAllHr = 'get-all-hr',
  getAllEmployees = 'employees',
}

export enum CompanyEndPoint {
  search = 'search',
}

export enum DiscountEndPoint {
  image = 'image',
  similar = 'similar',
  hr = 'hr',
  filter = 'filter',
  search = 'search',
  download = 'download',
  downloadByIds = 'download-by-ids',
  downloadByDate = 'download-by-date',
  dateBeginDesc = 'date-begin-desc',
  status = 'status',
  statusComments = 'status-comments',
  restoredFromArchive = 'restored-from-archive',
}

export enum CategoryEndPoint {
  mainPage = 'mainpage',
  subcategories = 'subcategories',
}

export enum LocationEndPoint {
  country = 'country',
  assignedHrs = 'assigned-hrs',
}

export enum NotificationsEndPoint {
  discountRequest = 'discount-demands',
}

export enum DiscountRequestEndPoint {
  setStatus = 'setStatus',
  assignToHr = 'assign-to-hr',
  my = 'my',
  history = 'history',
}

export enum BenefitsEndPoint {
  login = 'login',
}

export enum TopUserEndPoint {
  topUsers = 'top-users',
  topDiscounts = 'top-users/discounts',
}

export enum StatisticsEndPoint {
  quarterly = 'quarterly',
  quarterlyExport = 'quarterly/export',
}
